import React from 'react';
import { UsageRightRequest } from '../types';
import { useUsageRight } from '../UsageRightsProvider';
import styles from '../../../../styles/usageRights.module.css';
import MediaThumbnail from '../MediaThumbnail';
import { Button } from '../../../styledComponents';
import UsageRightStatusTag from '../UsageRightStatusTag';
import TypeTag from '../TypeTag';
import { dayjs } from '../../../../utils/dayjs-utils';

interface UsageRightCardProps {
  request: UsageRightRequest;
}

function UsageRightCard({ request }: UsageRightCardProps) {
  const { setSelectedRequest } = useUsageRight();

  return (
    <div className={styles.usageRightCard}>
      <div className={styles.usageRightCardLeftContainer}>
        <div className={styles.usageRightCardLabel}>Media:</div>
        <MediaThumbnail thumbnail={request?.thumbnail} type={request.type} />
      </div>
      <div className={styles.usageRightCardRightContainer}>
        <div className={styles.usageRightCardDetailItem}>
          <div className={styles.usageRightCardLabel}>Status:</div>
          <UsageRightStatusTag status={request?.status} />
        </div>
        <div className={styles.usageRightCardDetailItem}>
          <div className={styles.usageRightCardLabel}>Type:</div>
          <TypeTag type={request.type} />
        </div>
        <div className={styles.usageRightCardDetailItem}>
          <div className={styles.usageRightCardLabel}>Brand:</div>
          <div className={styles.brandContainer} style={{ textAlign: 'left' }}>
            {request.brandName}
          </div>
        </div>
        <div className={styles.usageRightCardDetailItem}>
          <div className={styles.usageRightCardLabel}>Date:</div>
          <div className={styles.cardDateContainer}>{dayjs(request?.creativeCreatedDate).format('MMM DD, YYYY')}</div>
        </div>
        <div className={styles.cardButtonContainer}>
          <Button
            bgColor="white"
            color="var(--purple-p-400)"
            style={{ border: '1px solid var(--purple-p-400)', padding: '4px 16px' }}
            onClick={() => setSelectedRequest(request)}
          >
            See Details
          </Button>
        </div>
      </div>
    </div>
  );
}

export default UsageRightCard;
